module.exports = {
      id: "video-whitebg-usage",
      viewBox: "0 0 44 44",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#video-whitebg",
      toString: function () {
        return this.url;
      }
    }